import { render, staticRenderFns } from "./Holiday.vue?vue&type=template&id=6df331ba&scoped=true&"
import script from "./Holiday.vue?vue&type=script&lang=js&"
export * from "./Holiday.vue?vue&type=script&lang=js&"
import style0 from "./Holiday.vue?vue&type=style&index=0&id=6df331ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df331ba",
  null
  
)

export default component.exports